import axios from 'axios'

const apiClient = axios.create({
  //baseURL: 'http://my-json-server.typicode.com/fandolfatto/VueAPIOptions/',
  //baseURL: 'http://localhost:3000',
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

export default {
  getEvents() {
    console.log("coucou")
    console.log(process.env.VUE_APP_API_URL)
    return apiClient.get('/api/activities')
  },
}
